<template>
  <div>
    <base-nav v-model="showMenu" type="light" :transparent="true" menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main bg-primary" expand="lg">
      <template v-slot:brand>
        <div class="navbar-wrapper">
          <router-link class="navbar-brand" to="/">
            <img src="img/brand/firefly-1.png" />
          </router-link>
        </div>
      </template>

      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand">
            <router-link to="/">
              <img src="img/brand/firefly-text.png" />
            </router-link>
          </div>
          <div class="col-6 collapse-close">
            <button type="button" class="navbar-toggler" @click="closeMenu">
              <span class=" bg-black"></span>
              <span class=" bg-black"></span>
            </button>
          </div>
        </div>
      </div>
      <ul class="navbar-nav mr-xxl--9">
        <div class="nav-item col-12 d-flex align-item-end justify-content-end mr-xxl--9">
          <base-button @click="signIn" type="default">SIGN IN</base-button>
        </div>
      </ul>
    </base-nav>
    <div class="main-content">
      <router-view></router-view>
    </div>
    <footer class="" id="footer-main">
      <div class="container">
        <div class="row">
          <p class="font text-white text-center px-0">
            Fintrens Technologies Private Limited. First Floor, Central Plaza, 22/800C, Jn, opp. Union Bank,
            Karingachira,
            Thrippunithura, Ernakulam, Kerala 682301 </p>
        </div> <br>
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-muted">
              © {{ year }}
              <a href="https://www.fintrens.com/" class="font-weight-bold ml-1" target="_blank">Copyright Fintrens</a>
            </div>
          </div>
          <div class="col-xl-6">
            <ul class="nav nav-footer justify-content-center justify-content-xl-end ">
              <li class="nav-item">
                <a href="https://www.docs.firefly.fintrens.com/" class="nav-link text-muted font-weight-bold"
                  target="_blank">Firefly</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.querySelector(".navbar-collapse").style.display = "none";
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
    signIn() {
      this.$store
        .dispatch("authStore/signIn", { root: true })
        .then(response => {
          const accessToken = sessionStorage.getItem("accessToken");
          if (accessToken) {
            this.$router.push('/techDashboard');
          }
        }
        )
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  beforeUnmount() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground();
      },
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;

@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>
